export default __webpack_public_path__ + "assets/icons/shipment-complaints.3aebc0c8.svg";